import { createRouter, createWebHistory } from "vue-router";

import CourseDetails from "@/views/CourseDetails.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/plans",
    name: "plans",
    component: () => import("../views/PlansView.vue"),
  },
  {
    path: "/contact-us",
    name: "contact_us",
    component: () => import("../views/ContactUsView.vue"),
  },
  {
    path: "/courses/:slug",
    name: "course_details",
    component: CourseDetails,
    props: true,
  },
  {
    path: "/terms_and_conditions",
    name: "terms_and_conditions",
    component: () => import("../views/TermsAndConditions.vue"),
    props: true,
  },
  {
    path: "/privacy_policy",
    name: "privacy_policy",
    component: () => import("../views/PrivacyPolicyView.vue"),
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }
    return { top: 0 };
  },
});

export default router;
